<template>
    <el-row type="flex" class="model-table-search btn-bg">
        <el-col :span="21">
            <el-row class="search-box" v-for="(data,indexs) in searchList" :key="indexs">
                <el-col
                    v-for="(item,index) in data"
                    :key="index"
                    :span="item.span"
                    v-show="indexs==='unfoldList'||unfoldState"
                    :class="{ 'is-fussy': item.isFussy }"
                >
                    <div class="search">
                        <el-input
                            v-if="item.type === 'advance'"
                            :placeholder="item.name"
                            :disabled="item.disabled"
                            :readonly="!item.advanceReadonly"
                            v-model="searchData[item.value]"
                            @keydown.113.native="detaliSearch(index, item, 1, searchData[item.value],indexs)"
                            @keyup.enter.native="detaliSearch(index, item, 1, searchData[item.value],indexs)"
                            @blur="item.advanceBlur ? detaliSearchBlur(index, item, 1, searchData[item.value],indexs) : false"
                            @clear="advanceCodeChange(indexs,index)"
                            @input="advanceCodeChange(indexs,index)"
                        >
                            <template v-slot:append>
                                <el-button
                                    :disabled="item.disabled"
                                    @click="detaliSearch(index, item, 1, searchData[item.value],indexs)"
                                    icon="el-icon-search"
                                ></el-button>
                            </template>
                            <template v-slot:suffix>
                                <i
                                    @click="resetAdvanceParams(item)"
                                    class="el-input__icon el-icon-circle-close"
                                    v-if="searchData[item.value]"
                                ></i>
                            </template>
                        </el-input>
                        <el-input
                            v-if="item.type === 'advanceMulti'"
                            :placeholder="item.name"
                            :disabled="item.disabled"
                            readonly
                            v-model="searchData[item.value]"
                            @keydown.113.native="detaliListSearch(index, item, 1, searchData[item.value],indexs)"
                            @keyup.enter.native="detaliListSearch(index, item, 1, searchData[item.value],indexs)"
                            @blur="item.advanceMultiBlur ? detaliListSearchBlur(index, item, 1, searchData[item.value],indexs) : false"
                            @clear="advanceCodeChange(indexs,index)"
                            @input="advanceCodeChange(indexs,index)"
                        >
                            <el-button
                                slot="append"
                                :disabled="item.disabled"
                                @click="detaliListSearch(index, item, 1, searchData[item.value],indexs)"
                                icon="el-icon-search"
                            ></el-button>
                            <i
                                slot="suffix"
                                @click="resetAdvanceParams(item)"
                                class="el-input__icon el-icon-circle-close"
                                v-if="searchData[item.value]"
                            ></i>
                        </el-input>
                        <el-input
                            v-if="item.type === 'input'"
                            :placeholder="item.placeholder || item.name"
                            :disabled="item.disabled"
                            @input="searchListChange(item, $event)"
                            :clearable="_.get(item, 'clearable', true)"
                            v-model="searchData[item.value]"
                            @keyup.enter.native="onSearchChange()"
                        >
                            <template v-if="item.selectConfig && item.selectConfig.option" #prepend>
                                <el-select
                                    v-model="item.selectConfig.value"
                                    :placeholder="item.selectConfig.placeholder || '请选择'"
                                    :class="item.selectConfig.class"
                                    :style="{ width: item.selectConfig.width || '60px' }"
                                    @change="inputSelectChange(item, $event)"
                                >
                                    <el-option
                                        v-for="(selItem, selIdx) in item.selectConfig.option"
                                        :key="selIdx"
                                        :label="selItem.label"
                                        :value="selItem.prop"
                                    ></el-option>
                                </el-select>
                            </template>
                            <template v-slot:append>
                                <el-button
                                    v-if="item.isFussy"
                                    :ref="`${item.value}FussyCheckboxBtn`"
                                    @click="handleChangeFussy(!searchData[item.value + 'Fussy'], item.value + 'Fussy', item)"
                                >{{$translate('component.E202007300017', { defaultText: '模糊' })}}</el-button>
                            </template>
                        </el-input>
                        <el-select
                            v-else-if="item.type === 'autocomplete'"
                            v-model="searchData[item.passValue?item.passValue:item.value]"
                            :disabled="item.disabled"
                            :clearable="_.get(item, 'clearable', true)"
                            :filterable="item.filterable"
                            remote
                            :multiple="item.multiple?item.multiple:false"
                            reserve-keyword
                            :placeholder="item.name"
                            :remote-method="remoteMethod"
                            collapse-tags
                            @change="autocompleteSure(item, $event)"
                            @clear="autocompleteSure(item, $event)"
                            @focus="searchDataChange(item)"
                            @keyup.enter.native="onSearchChange()"
                            :loading="searchLoading"
                        >
                            <el-option
                                v-for="selectItem in item.options"
                                :key="selectItem.id"
                                :label="selectItem.label"
                                :value="selectItem.passValue ? selectItem.value + '/' + selectItem.passValue : selectItem.value"
                            ></el-option>
                        </el-select>
                        <el-select
                            :clearable="_.get(item, 'clearable', true)"
                            :filterable="item.filterable"
                            :disabled="item.disabled"
                            @change="searchListChange(item, $event)"
                            @clear="searchListChange(item, $event)"
                            v-model="searchData[item.value]"
                            v-if="item.type === 'select'"
                            :multiple="item.multiple?item.multiple:false"
                            :placeholder="item.name"
                            collapse-tags
                            @keyup.enter.native="onSearchChange()"
                        >
                            <el-option
                                v-for="(val, index) in item.options"
                                :key="index"
                                :label="val.label"
                                :value="val.value"
                            ></el-option>
                        </el-select>
                        <el-cascader
                            @change="searchListChange(item, $event)"
                            :disabled="item.disabled"
                            v-model="searchData[item.value]"
                            v-if="item.type === 'cascader'"
                            :options="item.options"
                            collapse-tags
                            :filterable="item.filterable"
                            :change-on-select="item.changeOnSelect"
                            :placeholder="item.name"
                        ></el-cascader>
                        <addressSelect
                            v-if="item.type === 'addressSelect'"
                            :disabled="item.disabled"
                            @change="searchListChange(item, $event)"
                            v-model="searchData[item.value]"
                            :minLayers="item.minLayers"
                            :placeholder="item.name"
                            :basicProps="item.config"
                        ></addressSelect>
                        <addressCascader
                            v-if="item.type === 'addressCascader'"
                            v-model="searchData[item.value]"
                            :minLayers="item.minLayers"
                            :placeholder="item.name"
                            :basicProps="item.config"
                            :hotData="item.hotData"
                            :showNoChoice="item.showNoChoice"
                            :draggable="item.draggable"
                            @toChangeSelection="(value)=>searchData[item.value]=value"
                        ></addressCascader>
                        <el-date-picker
                            class="text-box"
                            :disabled="item.disabled"
                            @change="searchListChange(item, $event)"
                            v-if="item.type === 'time'"
                            v-model="searchData[item.value]"
                            size="mini"
                            :clearable="_.get(item, 'clearable', true)"
                            format="yyyy-MM-dd HH:mm:ss"
                            :value-format="item.format||'yyyy-MM-dd HH:mm:ss'"
                            :picker-options="pickerOptions"
                            :type="item.time?'daterange':'datetimerange'"
                            unlink-panels
                            :range-separator="$translate('component.E202007300014', { defaultText: '至' })"
                            :start-placeholder="item.startPlaceholder ? item.startPlaceholder : $translate('component.E202007300015', { defaultText: '开始日期' })"
                            :end-placeholder="item.endPlaceholder ? item.endPlaceholder : $translate('component.E202007300016', { defaultText: '结束日期' })"
                            :default-time="['00:00:00', '23:59:59']"
                        ></el-date-picker>
                        <el-date-picker
                            v-if="['date','week','month','dates','year'].includes(item.type)"
                            @change="searchListChange(item, $event)"
                            size="mini"
                            class="text-box"
                            v-model="searchData[item.value]"
                            :clearable="_.get(item, 'clearable', true)"
                            :format="item.format"
                            :value-format="item.valueFormat"
                            :type="item.type"
                            unlink-panels
                            :placeholder="item.placeholder ? item.placeholder : $translate('lotsUI.select_date', { defaultText: '选择日期' })"
                        ></el-date-picker>
                    </div>
                    <!-- <span class="input-append-fussy" v-if="item.isFussy">
                        <el-checkbox v-model="searchData[item.value + 'Fussy']">{{$translate('component.E202007300017', { defaultText: '模糊' })}}</el-checkbox>
                    </span>-->
                </el-col>
                <el-col v-if="indexs==='unfoldList'" class="select-btn-box">
                    <el-button
                        class="bigData-btn-search"
                        type="primary"
                        @click="onSearchChange()"
                        v-preventClick="list.isControl"
                        :loading="loading"
                    >{{$translate('component.E202006180033', { defaultText: '查 询' })}}</el-button>
                    <el-button type="text" v-if="list.unfoldState" @click="unloadChange">{{btnTxt}}</el-button>
                    <search-set
                        v-if="list.advancedBtn"
                        class="advanced-btn"
                        :searchId="searchId"
                        :initSearchInfo="initSearchInfo"
                        ref="searchSet"
                        :fieldTrim="list.fieldTrim"
                        :searchInitList="list.searchTxt"
                        @init-search="dataInit"
                        :longPrefix="longPrefix"
                        :configurationUrl="configurationUrl"
                        :advancePrefix="advancePrefix"
                        :pickerOptions="pickerOptions"
                        @handleVagueSearch="handleVagueSearch"
                        :popPrefix="popPrefix"
                        :setSearchData="searchData"
                        :searchTotalTitle="searchTotalTitle"
                        :isControl="list.isControl"
                        :keyMaps="keyMap"
                        @search="onSearchChange"
                        @search-list-change="searchListChange"
                    >
                        <template v-slot:search-append>
                            <slot name="search-append"></slot>
                        </template>
                    </search-set>
                </el-col>
                <slot name="search-list-advance-right"></slot>
            </el-row>
            <advance-dialog ref="advanceDialog" @confirm="detaliSearchSure"></advance-dialog>
            <advance-multi-dialog
                ref="advanceMultiDialog"
                @confirm="detaliListSearchSure"
                @getCheckedList="detailCheckedList"
            ></advance-multi-dialog>
        </el-col>
        <el-col :span="3">
            <el-row>
                <el-col>
                    <slot name="table-module-btn"></slot>
                </el-col>
            </el-row>
        </el-col>
    </el-row>
</template>
<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import searchSet from '../searchSet';
import { longRange } from '@/components/otpPanel/api';
import { dictWithUrl } from '@/components/lots/api';
import formatTime from '@/utils/common.js';
import _ from '@/components/lots/utils.js';
import addressSelect from '@/components/lots/otpCascader2';
import advanceDialog from '@/components/lots/otpAdvanceDialog';
import advanceMultiDialog from '@/components/lots/otpAdvanceMultiDialog';
import addressCascader from '@/components/lots/addressCascader';
import preventClick from '@/components/utils/directive';
import { I18nMixins } from '@/components/utils/i18n';
export default {
    mixins: [I18nMixins, preventClick],
    components: { searchSet, addressSelect, advanceDialog, addressCascader, advanceMultiDialog },
    props: {
        searchId: String,
        popPrefix: {
            type: String,
            default () {
                return '/api-mdm/dictionaryDetail/dict';
            }
        },
        advancePrefix: {
            type: String,
            default () {
                return '/api-mdm';
            }
        },
        longPrefix: {
            type: String,
            default () {
                return '/api-gwms/es/comboBox';
            }
        },
        configurationUrl: String,
        list: {
            type: Object,
            default () {
                return {};
            }
        },
        searchTotalTitle: {
            type: Array,
            default () {
                return [];
            }
        },
        filterable: Boolean,
        initSearchInfo: {
            type: Object,
            default () {
                return {};
            }
        },
        pickerConfig: {
            type: [Object, String],
            default () {
                return '';
            }
        }
    },
    data () {
        return {
            timer: null,
            btnTxt: '展开',
            searchChange: [],
            searchData: {},
            restaurantsList: [],
            searchList: {
                unfoldList: []
            },
            pickerOptions: {},
            unfoldState: false,
            optionList: [],
            advanced: false,
            searchNum: 0,
            searchTypeNum: '',
            selectItem: [],
            advanceUrl: '',
            advanceLabel: '',
            advanceCode: '',
            searchValue: '',
            options: [],
            searchLoading: false,
            loading: false,
            keyMap: {},
            advanceMultiCache: {},
            currentAdvanceMulti: {}
        };
    },
    methods: {
        // 高级内模糊搜索触发
        handleVagueSearch (e, key, item) {
            const parentNodeClassList = _.get(this, `$refs.${key}CheckboxBtn[0].$el.parentNode.classList`);
            this.$emit('handleFussyChange', item, e, key);
            if (!parentNodeClassList) return;
            if (e) {
                parentNodeClassList.add('isActive');
            } else {
                parentNodeClassList.remove('isActive');
            }
        },
        // input模糊搜索change，v-model无效
        handleChangeFussy (e, key, item) {
            this.searchData[key] = e;
            this.handleVagueSearch(e, key, item);
            const parentNodeClassList = _.get(this, `$refs.searchSet[0].$refs.${key}AdvancedCheckboxBtn[0].$el.parentNode.classList`);
            if (!parentNodeClassList) return;
            if (e) { // checkbox-button的checked不生效，只能动态生成和删除class，用于高级里面的模糊搜索高亮
                parentNodeClassList.add('isActive');
            } else {
                parentNodeClassList.remove('isActive');
            }
        },
        // input 左边下拉框切换值
        inputSelectChange (item, val) {
            const optionItem = item.selectConfig.option.find(s => s.prop === val);
            item.placeholder = optionItem.label;
            this.searchData[item.selectConfig.prop] = val;
        },
        unloadChange () {
            this.unfoldState = !this.unfoldState;
            if (this.btnTxt === this.$translate('component.E202006230014', { defaultText: '展开' })) {
                this.btnTxt = this.$translate('component.E202006230013', { defaultText: '收起' });
                this.unfoldState = true;
            } else {
                this.btnTxt = this.$translate('component.E202006230014', { defaultText: '展开' });
                this.unfoldState = false;
            }
        },
        detaliSearchBlur (index, current, type, searchData, num) {
            searchData = this.trimOrReplaceSpace(searchData);
            if (searchData !== '' && !current.advanceReadonly) {
                setTimeout(this.detaliSearch(index, current, type, searchData, num), 500);
            }
        },
        detaliListSearchBlur (index, current, type, searchData, num) {
            searchData = this.trimOrReplaceSpace(searchData);
            if (searchData !== '') {
                setTimeout(this.detaliListSearch(index, current, type, searchData, num), 500);
            }
        },
        detaliSearch (index, current, type, searchData, num) {
            // const value = this.searchData[current.value];
            // const code = this.searchData[current.advanceCode];
            // this.advanceUrl = current.advanceUrl;
            // this.advanceLabel = current.label ? current.label : current.name;
            // this.searchTypeNum = num;
            // this.searchNum = index;
            // this.advanceCode = current.advanceCode;
            // this.$refs.detaliTable.showState = true;
            // 高级搜索级联操作，current.advanceCascade为需要级联的参数的key的集合，例如advanceCascade: key1,key2,key3
            // 处理搜索条件前置效验(用于关联查询必填查询条件)
            // preValidation:前置效验参数
            // preValidationTip:前置效验参数未选提示
            if (current.preValidation) {
                if (!this.searchData[current.preValidation]) {
                    return this.$message.warning(current.preValidationTip);
                }
            }
            const advanceCascade = {};
            if (current.advanceCascade && Object.prototype.toString.call(current.advanceCascade) === '[object String]') {
                let advanceArray = [];
                advanceArray = current.advanceCascade.split(',');
                advanceArray.map((item) => {
                    let { 0: sourceProp, 1: destProp } = item.split('#');
                    destProp = destProp || sourceProp;
                    advanceCascade[destProp] = this.searchData[sourceProp];
                });
            }
            // advanceRequire 作某个联动值的空值校验[{ 'prop': 'xxx', 'message': 'xxx' }]，prop为联动值字段，message为空值时输出信息
            const { mode, advanceRequire } = current;
            if (advanceRequire && advanceRequire.length > 0) {
                let flag = true;
                advanceRequire.forEach(ad => {
                    if (!this.searchData[ad.prop]) {
                        flag = false;
                        this.$message.warning(ad.message);
                    }
                });
                if (!flag) { return false; }
            }
            // this.$refs.detaliTable.inquire(this.advanceUrl, value, current, true, code, advanceCascade);
            this.$refs.advanceDialog.show(true, current, advanceCascade, mode, [], searchData);
        },
        detaliListSearch (index, current, type, searchData, num) {
            // advanceCascade: 'sourceSystem#source_system' // 级联参数 —— 格式：级联属性#查询属性,级联属性#查询属性....(选填)
            // 高级搜索级联操作，current.advanceCascade为需要级联的参数的key的集合，例如advanceCascade: key1,key2,key3
            const advanceCascade = {};
            if (current.advanceCascade && Object.prototype.toString.call(current.advanceCascade) === '[object String]') {
                let advanceArray = [];
                advanceArray = current.advanceCascade.split(',');
                advanceArray.map((item) => {
                    let { 0: sourceProp, 1: destProp } = item.split('#');
                    destProp = destProp || sourceProp;
                    advanceCascade[destProp] = this.searchData[sourceProp];
                });
            }
            // advanceMultiCache：缓存选中数据
            this.currentAdvanceMulti = current;
            if (!this.advanceMultiCache[current.value]) this.advanceMultiCache[current.value] = [];
            const cache = this.advanceMultiCache[current.value];
            this.$refs.advanceMultiDialog.show(true, current, advanceCascade, cache.length ? cache : undefined);
        },
        searchListChange (config, data) {
            this.$emit('search-list-change', config, data);
        },
        detaliSearchSure (data, config) {
            // 将返回数据添加到map里，用于高级搜索清空时，顺带清空其他关联属性
            const keyArr = Object.keys(data);
            if (keyArr.length > 0) {
                keyArr.forEach(key => {
                    this.keyMap[key] = keyArr;
                });
            }
            Object.assign(this.searchData, data);
            this.searchListChange(config, data);
        },
        detaliListSearchSure (data) {
            const keyArr = Object.keys(data[0]);
            const params = {};
            keyArr.forEach(key => {
                this.keyMap[key] = keyArr;
                if (!params[key]) params[key] = [];
                data.forEach(item => {
                    params[key].push(item[key]);
                });
                params[key] = params[key].join();
            });
            Object.assign(this.searchData, params);
            this.searchListChange(this.currentAdvanceMulti, data);
        },
        detailCheckedList (data) {
            this.advanceMultiCache[this.currentAdvanceMulti.value] = data;
        },
        onSearchChange (data, isExport) {
            // this.searchData = { ...this.searchData, ...data };
            // let searchData = JSON.stringify(this.searchData);
            // searchData = JSON.parse(searchData);
            const searchDataCopy = JSON.parse(JSON.stringify(this.searchData));
            const searchData = data ? { ...searchDataCopy, ...data } : searchDataCopy;
            for (const key in searchData) {
                if (typeof (searchData[key]) === 'string') {
                    searchData[key] = this.trimOrReplaceSpace(searchData[key]);
                }
            }
            if (data && !data.isTrusted) {
                for (const key in data) {
                    if (typeof (data[key]) === 'string') {
                        searchData[key] = this.trimOrReplaceSpace(data[key]);
                    }
                }
            }
            if (searchData.searchTime) {
                const startDate = searchData.searchTime[0];
                const endDate = searchData.searchTime[1];
                if (typeof (startDate) === 'object') {
                    const startTime = this.formatTime(startDate);
                    const endTime = this.formatTime(endDate);
                    searchData.startTime = startTime + ' 00:00:00';
                    searchData.endTime = endTime + ' 23:59:59';
                } else {
                    searchData.startTime = formatTime.formatDateTime(startDate);
                    searchData.endTime = formatTime.formatDateTime(endDate);
                }
            }
            if (this.searchChange.length !== 0) {
                this.searchChange.map(item => {
                    if (item.value !== item.startValue && item.value) {
                        delete searchData[item.endValue];
                    }
                });
            }
            if (isExport) {
                return searchData;
            } else {
                this.$emit('onSearchChange', searchData);
            }
        },
        formatTime (time) {
            const year = time.getFullYear();
            const mouth = this.disposeTime(time.getMonth() + 1);
            const day = this.disposeTime(time.getDate());
            return year + '-' + mouth + '-' + day;
        },
        disposeTime (time) {
            if (time < 10) {
                return '0' + time;
            } else {
                return time;
            }
        },
        getOptionList () {
            const optionNums = this.list.searchTxt.length > 0 ? this.list.searchTxt.filter(item => item.optionNum).map(item => item.optionNum).join(',') : '';
            if (optionNums) {
                const params = {
                    dictCodes: optionNums,
                    tenantCode: this.currentTenant.tenantCode
                };
                dictWithUrl(params).then(data => {
                    if (data.code === '0') {
                        this.list.searchTxt.forEach(item => {
                            if (item.optionNum) {
                                item.options = Object.entries(data.data[item.optionNum]).map(item => {
                                    return {
                                        value: item[0],
                                        label: item[1]
                                    };
                                });
                            }
                        });
                    }
                });
            }
        },
        dataInit (val, reset = false) {
            const searchData = {};
            const initSearchInfo = val || this.initSearchInfo;
            this.searchChange = [];
            this.searchList.unfoldList = [];
            this.list.searchTxt.forEach((data) => {
                if (reset || !initSearchInfo[data.value]) {
                    if (data.type === 'time' && data.timeNum) {
                        const today = dayjs();
                        const startOfDay = today.startOf('day');
                        const endOfDay = today.endOf('day');
                        const start = data.future ? startOfDay.toDate() : startOfDay.subtract(data.timeNum, 'd').toDate();
                        const end = data.future ? endOfDay.add(data.timeNum, 'd').toDate() : today.endOf('day').toDate();
                        searchData[data.value] = [start, end];
                    } else if (data.type === 'time' && data.interval) {
                        const start = dayjs().startOf('month').format('YYYY-MM-DD 00:00:00');
                        const end = dayjs().add(1, 'month').endOf('month').format('YYYY-MM-DD 23:59:59');
                        searchData[data.value] = [start, end];
                    } else if (data.type === 'advance') {
                        if (this.keyMap[data.value]) {
                            this.keyMap[data.value].forEach(key => { searchData[key] = ''; });
                        } else {
                            searchData[data.value] = '';
                        }
                    } else if (data.type === 'input' && data.selectConfig) {
                        const { selectConfig } = data;
                        searchData[selectConfig.prop] = selectConfig.value || selectConfig[selectConfig.option[0].prop];
                    } else {
                        let item = '';
                        if (data.data) {
                            item = data.data;
                        } else if ((data.multiple && data.multiple === true) || data.type === 'cascader' || data.type === 'addressSelect') {
                            item = [];
                        }
                        if (data.passValue) {
                            this.searchChange.push({
                                startValue: data.ganged,
                                endValue: data.value,
                                value: data.passValue
                            });
                        }
                        searchData[data.value] = item;
                    }
                } else {
                    searchData[data.value] = initSearchInfo[data.value];
                }
                if (data.unfold === true) {
                    this.searchList.unfoldList.push(data);
                }
            });
            this.$emit('clear');
            this.searchData = searchData;
        },
        getRemoteMethod (query) {
            this.options = [];
            let searchData;
            if (query) {
                searchData = this.trimOrReplaceSpace(query);
            } else {
                searchData = '';
            }
            const params = {
                [this.selectItem.tableName]: {
                    [this.selectItem.value]: searchData,
                    [this.selectItem.ganged]: searchData
                }
            };
            if (this.selectItem.relevanceOne) {
                const temp = this.selectItem.relevanceOnePlace || this.selectItem.relevanceOne;
                params[this.selectItem.tableName][temp] = Array.isArray(this.searchData[this.selectItem.relevanceOne])
                    ? this.searchData[this.selectItem.relevanceOne].join(',') : this.searchData[this.selectItem.relevanceOne];
            }
            if (this.selectItem.relevanceTwo) {
                const temp = this.selectItem.relevanceTwoPlace || this.selectItem.relevanceTwo;
                params[this.selectItem.tableName][temp] = Array.isArray(this.searchData[this.selectItem.relevanceTwo])
                    ? this.searchData[this.selectItem.relevanceTwo].join(',') : this.searchData[this.selectItem.relevanceTwo];
            }
            const longPrefix = this.selectItem.longPrefix || this.longPrefix;
            longRange(longPrefix, params).then(data => {
                const restaurants = [];
                if (data.data[this.selectItem.tableName]) {
                    data.data[this.selectItem.tableName].map(search => {
                        restaurants.push({
                            'value': search[this.selectItem.ganged],
                            'label': search[this.selectItem.value],
                            'passValue': search[this.selectItem.autocompExtra],
                            'id': search[this.selectItem.uniqueID || 'id']
                        });
                    });
                }
                this.searchLoading = true;
                setTimeout(() => {
                    this.searchLoading = false;
                    this.$nextTick(() => {
                        this.$set(this.selectItem, 'options', restaurants);
                    });
                }, 20);
            });
        },
        // 远程搜索
        remoteMethod (query) {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {
                this.getRemoteMethod(query);
            }, 300);
        },
        autocompleteSure (item, value) {
            if (item.relevanceClear) {
                item.relevanceClear.map(item => {
                    if (this.searchData[item]) {
                        this.searchData[item] = '';
                    }
                });
            }
            this.searchListChange(item, value);
        },
        searchDataChange (item) {
            this.selectItem = item;
            this.remoteMethod();
        },
        advanceCodeChange (num, index) {
            this.searchData[this.searchList[num][index].advanceCode] = '';
        },
        changeLoading (status) {
            this.loading = status;
            if (this.$refs.searchSet) {
                this.$refs.searchSet[0].changeLoading(status);
            }
        },
        // 高级输入框的关闭按钮点击
        resetAdvanceParams (item) {
            const prop = item.value;
            const keyArr = this.keyMap[prop];
            // 把属性相关联的字段置空
            if (item.advanceReadonly) {
                this.searchData[item.value] = '';
            } else {
                keyArr.forEach(key => {
                    this.searchData[key] = '';
                });
            }
            if (this.advanceMultiCache[item.value]) {
                this.advanceMultiCache[item.value] = [];
            }
            this.searchListChange(item, '');
        },
        // 初始化pickerOptions.shortcuts
        initPickerShortcuts () {
            // 初始化配置
            const defaultDay = [6, 1, 2];
            const defaultOption = {
                shortcuts: [
                    { type: 'd', num: defaultDay[0], text: '最近一周', translate: 'component.E202007300011' },
                    { type: 'M', num: defaultDay[1], text: '最近一个月', translate: 'component.E202007300013' },
                    { type: 'M', num: defaultDay[2], text: '最近两个月', translate: 'component.E1202104120940' }
                ]
            };
            if (Object.prototype.toString.call(this.pickerOptions) !== '[object Object]' || (this.pickerOptions.shortcuts && !this.pickerOptions.shortcuts.length)) {
                this.pickerOptions = defaultOption;
            }
            const _this = this;
            this.pickerOptions.shortcuts = this.pickerOptions.shortcuts.map(item => {
                return {
                    text: this.$translate(item.translate, { defaultText: item.text || '最近一周' }),
                    onClick (picker) {
                        const today = dayjs();
                        const startOfDay = today.startOf('day');
                        const endOfDay = today.endOf('day');
                        const start = item.future ? startOfDay.toDate() : startOfDay.subtract(item.num || defaultDay[0], item.type || 'd').toDate();
                        const end = item.future ? endOfDay.add(item.num || defaultDay[0], item.type || 'd').toDate() : endOfDay.toDate();
                        const text = _this.$translate(item.translate, { defaultText: item.text });
                        picker.$emit('pick', [start, end]);
                        window._paq && window._paq.push(['trackEvent', 'datepicker', 'date', text]);
                    }
                };
            });
        },
        trimOrReplaceSpace (str) {
            if (this.list.fieldTrim) {
                return (str || '').trim();
            } else {
                return (str || '').replace(/\s*/g, '');
            }
        }
    },
    watch: {
        tableData: function () {
            this.dataInit();
        },
        list: {
            handler: function (newList) {
                if (newList.searchTxt) {
                    newList.searchTxt.forEach(item => {
                        if (item.defaultValue) {
                            // this.searchData[item.value] = item.defaultValue;
                            ((item2) => {
                                this.$nextTick(() => {
                                    this.$set(this.searchData, item2.value, item2.defaultValue);
                                });
                            })(item);
                        }
                    });
                }
            }
        },
        initSearchInfo: {
            handler (val) {
                this.dataInit(val);
            }
        },
        pickerConfig: {
            handler (val) {
                this.pickerOptions = val;
                this.initPickerShortcuts();
            },
            immediate: true
        }
    },
    created () {
        this.dataInit();
        this.getOptionList();
        this.$eventBus.$on(this.$route.name, () => this.dataInit());
    },
    computed: {
        ...mapGetters(['currentTenant']),
        _ () {
            return _;
        }
    }
};
</script>
<style lang="less">
.model-table-search {
    .search-box {
        flex-wrap: wrap;
        white-space: nowrap;
        .is-fussy {
            display: flex;
            .el-input-group--append {
                .el-input-group__append {
                    background-color: #fff;
                }
                .isActive {
                    background-color: #00bcbf;
                    color: #fff;
                }
            }
            .search {
                flex: auto;
            }
            .input-append-fussy {
                flex: none;
                flex-basis: 65px;
                align-self: baseline;
                margin-top: 4px;
                .el-checkbox__label {
                    padding-left: 4px;
                }
            }
        }

        .search {
            margin: 0 8px 10px 0;
        }

        .advanced-btn {
            margin-left: 10px;
        }
    }

    .text-box {
        position: relative;
        font-size: 12px;
        width: 100%;
    }

    .select-btn-box {
        width: auto;
    }

    .el-autocomplete,
    .el-select {
        width: 100%;
    }
    .el-input-group__prepend {
        .el-input__inner {
            padding-right: 16px;
        }
        .el-select {
            width: 60px;
        }
        .el-input__suffix {
            right: 2px;
        }
    }
}
</style>
